<template>
 <div class="a-autocomplete--container">
   <text-field v-model="textFieldVal" @focus="textFieldVal = '';textFieldActive=true" @blur="textFieldActive=false" :width="width" />
   <div class="items-container" v-show="showMenu">
     <div class="item" v-for="(item, i) in filteredItems" :key="i" @click="setValue(item)">
       {{typeof item === 'string' ? item : item[itemText]}}
     </div>
     <div class="item" v-if="allowAdd && filteredItems.length < 1" @click="setValue(textFieldVal)">{{`Add '${textFieldVal}'`}}</div>
   </div>
 </div>
</template>

<script>
import TextField from "@/components/SelfService/text-field";
export default {
  name: "a-autocomplete",
  components: {TextField},
  props: {
    items: {
      type: Array,
      default(){return []}
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    allowAdd: {
      type: Boolean,
      default() {
        return false;
      }
    },
    width: {
      type: [Number, String]
    }
  },
  data() {
    return {
      textFieldVal: '',
      textFieldActive: false,
      showMenu: false,
      internalValue: ''
    }
  },
  watch:{
    textFieldActive(newVal){
      setTimeout(() => {
        this.showMenu = newVal
      }, 200)
    },
  },
  methods: {
    setValue(val){
      let returnValue, textValue;
      if (typeof val === 'string') {
        returnValue = val
        textValue = val
      }
      else {
        textValue = val[this.itemText] || ''
        returnValue = this.returnObject ? val : (val[this.itemValue] || undefined)
      }
      this.textFieldVal = textValue
      this.$emit('input', returnValue)
    }
  },
  computed: {
    filteredItems(){
      let searchQuery = this.textFieldVal ? this.textFieldVal.toLowerCase() : '';
      return this.items.filter((item) => {
          const itemText = (typeof item === 'string') ? item : item[this.itemText] || ''

          return searchQuery === ''
            ? true
            : itemText.toLowerCase().includes(searchQuery)
        }
      );
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/SelfService/colors.scss";
@import "~@/styles/SelfService/effects.scss";

.a-autocomplete--container{
  position: relative;
  display: inline-block;

  .items-container{
    position: absolute;
    width: 100%;
    max-height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    contain: content;

    background: $background;
    border: 1px solid $primary;
    box-shadow: $hover--s;
    border-radius: 12px;
    margin: 2px 0;
    padding: 5px 0;



    .item{
      padding: 5px 10px;
      cursor: pointer;
      position: relative;

      //&:last-child{
      //  padding: 10px;
      //}
      //&:first-child{
      //  padding: 10px;
      //}

      &:hover:before {
        opacity: .04;
      }
    }

    .item:before {
      background-color: currentColor;
      bottom: 0;
      content: "";
      left: 0;
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;
      transition: .3s cubic-bezier(.25,.8,.5,1);
    }
  }
}
</style>
